<div class="autocomplete-container">
	<!-- Container for the autocomplete widget -->
	<div id="autocomplete"></div>
</div>
